import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";

import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelMoneyWithRefInput,
  SideLabelAutoCompleteWithRefInput
} from "../FormSectionComponents";

const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;
class LeasingChildSection extends React.Component {
  render() {
    const { isEditing } = this.props;

    return (
      <div id="covenants_section_leasing">
        <ChildSectionTitle>Leasing</ChildSectionTitle>
        <StyledGrid container alignItems="center" direction="column">

          <SideLabelTextAreaWithRefInput label="EOD Trigger" hasBorder placeholder="EOD Trigger" fieldName="covenants.leasingEODTrigger" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="EOD Cure" hasBorder placeholder="EOD Cure" fieldName="covenants.leasingEODCure" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Leasing Covenants" hasBorder placeholder="Leasing Covenants" fieldName="covenants.leasingCovenants" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Leasing Restrictions" hasBorder placeholder="Leasing Restrictions" fieldName="covenants.leasingRestrictions" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput
            label="Misc."
            placeholder="Misc."
            fieldName="covenants.leasingMisc"
            isDisabled={!isEditing}
          />
        </StyledGrid>
      </div>
    );
  }
}
export default LeasingChildSection;
